<script lang="ts">
  import NestedFormSet from "../../lib/dataform/NestedFormSet.svelte";
  import AddressConfirmed from "../CheckboardConsentTask/AddressConfirmed.svelte";
  import AddressSearch from "../CheckboardConsentTask/AddressSearch.svelte";
  import FooterButtons from "../../components/workflow/FooterButtons.svelte";
  import ContinueButton from "../../components/workflow/ContinueButton.svelte";
  import Plus from "~icons/ph/plus-circle-bold";
  import { scrollIntoView } from "../../lib/dom";

  let addAddress = $state<boolean>(false);
</script>

<h2 class="ui-title">Your financing addresses</h2>

<p class="mb-2">
  In the list below, include any addresses you may have used when taking out a finance agreement.
</p>

<p class="text-sm text-gray-600 font-medium">
  The soft credit check will use these addresses to find agreements we may be able to help you with.
</p>

<div class="flex flex-col gap-2">
  <NestedFormSet name="sourced_addresses">
    <AddressConfirmed />
    {#snippet add(addItem)}
      <div class="mt-2">
        {#if addAddress}
          <div {@attach scrollIntoView({ behavior: "smooth", block: "center" })}>
            <div class="mb-1.5">Search for address</div>
            <AddressSearch confirm={(address) => { addItem(address); addAddress = false; }} autofocus />
          </div>
        {:else}
          <button
            type="button"
            class="text-blue-600 underline font-semibold flex gap-2 items-center"
            onclick={() => addAddress = true}
          >
            <Plus class="w-4 h-4" /> Add address
          </button>
        {/if}
      </div>
    {/snippet}
  </NestedFormSet>
</div>

<FooterButtons back={false}>
  <ContinueButton type="submit" label="Done" class="btn-primary w-full" />
</FooterButtons>
